import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  SkiResortDetails,
  SkiResortsFilter,
} from '../../features/skiResorts/skiResortsSlice';

export function fetchSkiResorts(skiResortsFilter: SkiResortsFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: skiResortsFilter,
  };

  return axios
    .get('/location/skiresorts/getskiresorts', config)
    .then(res => res.data);
}

export function fetchSkiResortDetails(skiResortId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { skiResortId },
  };

  return axios
    .get('/location/skiresorts/getskiresortdetails', config)
    .then(res => res.data);
}

export function addSkiResort(skiResortData: SkiResortDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/location/skiresorts/addskiresort', skiResortData, config)
    .then(res => res.data);
}

export function updateSkiResort(skiResortData: SkiResortDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put('/location/skiresorts/updateskiresort', skiResortData, config)
    .then(res => res.data);
}

export function deleteSkiResort(skiResortId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { skiResortId },
  };

  return axios
    .delete('/location/skiresorts/deleteskiresort', config)
    .then(res => res.data);
}
